// ═══ v2 디자인 토큰 (수출업체 리디자인 W0 — BRIEF §3 계약) ═══
// 값의 출처: 말소대행 개편 실측(plan.md §1 — CancelAgencyDashboard.js `C`, App.css .ca-clean/.done-ledger,
// CancelAgencyClients.js 패널) + 시안 mockups/exporter.html. 새 색·반경·그림자를 여기 밖에서 만들지 않는다.
// v2/ 아래 다른 파일은 hex 리터럴 0 — v2-kit.test.js 가 grep 으로 지킨다.

export var T = {
  canvas: '#f0f2f5', card: '#fff', bd: '#e2e8f0', bdSoft: '#f1f5f9', head: '#f8fafc',
  ink: '#0f172a', navy: '#1B3A5C', accent: '#2563EB', accentPress: '#1d4ed8', accentTint: '#eff6ff', accentBd: '#bfdbfe',
  sub: '#5b6b7f', muted: '#64748b', faint: '#94a3b8', hair: '#e2eaf4', money: '#0f5132',
  danger: '#b91c1c', dangerTint: '#fef2f2', dangerBd: '#fecaca',
  warn: '#92400e', warnTint: '#fffbeb', warnBd: '#fcd34d',
  ok: '#047857', okTint: '#ecfdf5', okBd: '#a7f3d0',
  heroBg: 'linear-gradient(180deg,#fbfdff,#f4f8fd)', heroBd: '#dbe6f3',
  shadowPanel: '-8px 0 32px rgba(0,0,0,.16)', shadowMenu: '0 8px 24px rgba(0,0,0,.14)', shadowSheet: '0 -8px 32px rgba(0,0,0,.2)',
  // ── 시안 보조색 (BRIEF §3 표 밖, 값은 exporter.html 실측 — 새 색이 아니라 시안이 이미 쓰는 색) ──
  body: '#334155',        // 표 본문·버튼·칩 글자 (.dl td / .btn / .chip)
  dim: '#475569',         // 밴드 행·읽기전용 입력·범례 (.band / .in.ro / .legend)
  line: '#cbd5e1',        // 체크박스·라디오 테두리 (.dl .chk)
  track: '#e9eef5',       // 마이크로 스트립 바탕 (.strip)
  red: '#dc2626',         // 탭 배지·큐 danger 점 (.seg em / .q .dot.d)
  dotWarn: '#f59e0b',     // 큐 warn 점 (.q .dot.w)
  dotInfo: '#3b82f6',     // 큐 info 점 (.q .dot.i)
  bandBg: '#f3f7fc', bandBd: '#e4ecf6', rowHover: '#fafcff'   // 장부 밴드·hover (.done-ledger 실측)
};

// 차량 상태 색 — 앱 lib/design/tokens/status.dart 와 동일 (D5). 웹 v1 FLOW_COLOR 는 v1 화면용으로만 남는다.
export var STATUS_ORDER = ['등록완료', '말소신청', '말소완료', '면장신청', '면장완료', '선적대기', '선적완료', '폐차'];
export var STATUS = {
  '등록완료': '#2563EB', '말소신청': '#EA580C', '말소완료': '#7C3AED', '면장신청': '#CA8A04',
  '면장완료': '#0D9488', '선적대기': '#4F46E5', '선적완료': '#059669', '폐차': '#991B1B'
};
export function statusColor(name) { return STATUS[name] || T.muted; }

// '#rrggbb' / '#rgb' → 'rgba(r,g,b,a)'. 시안의 color-mix(9%/30%) 를 런타임에서 재현한다.
export function tint(hex, alpha) {
  var h = String(hex || '').replace('#', '');
  if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  var n = parseInt(h, 16);
  if (isNaN(n) || h.length !== 6) return 'rgba(100,116,139,' + alpha + ')';
  return 'rgba(' + ((n >> 16) & 255) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',' + alpha + ')';
}

export var R = { sm: 6, md: 8, card: 10, lg: 12, pill: 999 };
export var NUM = { fontVariantNumeric: 'tabular-nums' };
export var FONT = { hero: 21, title: 19, cardTitle: 13, tab: 13.5, body: 12.5, label: 11, badge: 10.5 };

// ── 정적 스타일 객체 — 모듈 스코프에 한 번만 만든다(핫루프에서 새 객체 금지). 화면은 Object.assign({}, S.x, 보정) 로 확장.
var input = {
  height: 34, border: '1px solid ' + T.bd, borderRadius: 7, padding: '0 10px', fontSize: 13, color: T.ink,
  background: T.card, width: '100%', boxSizing: 'border-box', fontFamily: 'inherit', outline: 'none',
  fontVariantNumeric: 'tabular-nums'
};
var btn = {
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 5, fontSize: 12.5, fontWeight: 600,
  padding: '0 12px', height: 32, borderRadius: 7, border: '1px solid ' + T.bd, background: T.card, color: T.body,
  whiteSpace: 'nowrap', cursor: 'pointer', fontFamily: 'inherit', lineHeight: 1
};
var chip = {
  display: 'inline-flex', alignItems: 'center', gap: 6, height: 28, padding: '0 10px', borderRadius: R.pill,
  border: '1px solid ' + T.bd, background: T.card, fontSize: 12, color: T.body, cursor: 'pointer',
  fontFamily: 'inherit', whiteSpace: 'nowrap'
};

export var S = {
  card: { background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card, overflow: 'clip' },
  cardHead: { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderBottom: '1px solid ' + T.bd, background: T.head },
  cardTitle: { fontSize: FONT.cardTitle, fontWeight: 800, color: T.ink, letterSpacing: '-.2px' },
  cardCount: { fontSize: 12, color: T.muted, fontVariantNumeric: 'tabular-nums' },
  cardRight: { marginLeft: 'auto', fontSize: 11.5, color: T.faint, display: 'flex', alignItems: 'center', gap: 8 },

  label: { display: 'block', fontSize: FONT.label, fontWeight: 700, color: T.muted, marginBottom: 4 },
  input: input,
  inputRo: Object.assign({}, input, { background: T.head, color: T.dim }),
  select: Object.assign({}, input, { cursor: 'pointer' }),
  textarea: Object.assign({}, input, { height: 'auto', minHeight: 80, padding: '8px 10px', lineHeight: 1.5, resize: 'vertical' }),

  btn: btn,
  // 변형은 base 의 `border` 단축을 **단축으로 통째 교체**한다. 단축 위에 borderColor 롱핸드를 얹으면
  // 변형↔base 교체(칩 토글·버튼 변형) 때 키 집합이 달라져 React 가 "Removing a style property during
  // rerender (borderColor)" 경고를 내고 테두리색이 지워진 채 남는다. v2 전역 규칙: border 는 단축만.
  btnPrimary: Object.assign({}, btn, { background: T.accent, border: '1px solid ' + T.accent, color: T.card }),
  btnNavy: Object.assign({}, btn, { background: T.navy, border: '1px solid ' + T.navy, color: T.card }),
  btnDanger: Object.assign({}, btn, { background: T.card, border: '1px solid ' + T.dangerBd, color: T.danger }),
  btnGhost: Object.assign({}, btn, { border: '1px solid transparent', background: 'transparent', color: T.muted }),
  btnSm: { height: 26, padding: '0 9px', fontSize: 11.5, borderRadius: R.sm },

  chip: chip,
  chipOn: Object.assign({}, chip, { border: '1px solid ' + T.accentBd, background: T.accentTint, color: T.accentPress, fontWeight: 700 }),
  secTitle: { display: 'flex', alignItems: 'center', gap: 10, margin: '18px 0 8px', fontSize: FONT.label, fontWeight: 800, color: T.muted, letterSpacing: '.3px' },
  emptyText: { padding: 26, textAlign: 'center', color: T.faint, fontSize: FONT.body },
  link: { fontSize: 12, fontWeight: 700, color: T.accentPress, cursor: 'pointer', background: 'none', border: 'none', padding: 0, fontFamily: 'inherit' }
};

// ── 숫자 포맷 — 0/null/NaN → '-' (BRIEF §1.9). 금액은 소수점 없이 천단위 콤마.
export function fmtNum(n) {
  var v = Number(n);
  if (!v || isNaN(v)) return '-';
  return Math.round(v).toLocaleString();
}
export function fmtMan(won) {            // 원 → 만원 단위 정수
  var v = Number(won);
  if (!v || isNaN(v)) return '-';
  return fmtNum(Math.round(v / 10000));
}
export function fmtWon(won) { return fmtNum(won); }
// 지표·문장 안의 0 은 '0' 으로 읽혀야 한다 (fmtNum/fmtMan 의 '-' 는 표 빈 셀 규칙). '합계 -만원' / '선적 30일 -대' 방지.
export function zeroText(s) { return s === '-' ? '0' : s; }
